/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationFilterBase {
    getFixupPrototypeFunction() { return RecommendationFilterBase.fixupPrototype; }

    static newInstance(model: Partial<RecommendationFilterBase>): RecommendationFilterBase {
        let obj = Object.assign(new RecommendationFilterBase(), model);
        RecommendationFilterBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationFilterBase>): RecommendationFilterBase {
        if (!model) return null;
        return RecommendationFilterBase.newInstance(<RecommendationFilterBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationFilterBase) {
        if (!obj) return;

        models.RecommendationFilterBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationFilterBase): boolean {
        Object.setPrototypeOf(obj, RecommendationFilterBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of Tenant Ids to get the recommendation rules.
     */
    tenant_ids: Array<string>;

    /**
     * List of service account IDs to get the recommendation details. If empty, all accounts will be selected by default.
     */
    service_account_ids: Array<string>;

}
